module.exports = __webpack_public_path__ + "static/media/profile-photo.7ef55d16.jpg";